import React from 'react'
import { useDrawerDetailTheme } from '../../DrawerDetailContext'
import Icon from 'src/shared/icons'
import { IconNamesProps } from 'src/shared/icons/Icon'
import './DrawerDetailIcon.css'

const DrawerDetailIcon = (iconProps: IconNamesProps ) => {
    const { color } = useDrawerDetailTheme()

    return (
        <div className='drawer-detail__icon'>
            <Icon {...iconProps} width={16} height={16} color={color} />
        </div>
    )
}

export default DrawerDetailIcon